import classnames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import { gettext } from "web/script/modules/django-i18n";
import { numberFormat } from "web/script/modules/formats";
import { DesignerPropType } from "web/types/designer";
import Conditional from "web/react/components/conditional/conditional";
import TrackedButton from "web/react/components/tracked-button/tracked-button";
import Button from "../button/button";
import styles from "./oos-hero.css";


class OOSHero extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            progress: props.startNum / props.numStores,
            complete: false,
        };

        this.animate = this.animate.bind(this);
        this.animationFrame = null;
        this.animationStart = 0;
    }

    componentWillUnmount() {
        if (this.animationFrame) {
            window.cancelAnimationFrame(this.animationFrame);
        }
    }

    componentDidMount() {
        this.beginAnimating();
    }

    componentDidUpdate(prevProps) {
        // Reset for storybook
        if (this.props != prevProps) {
            this.setState({
                progress: this.props.startNum / this.props.numStores,
                complete: false,
            });
            this.beginAnimating();
        }
    }

    beginAnimating() {
        this.animationStart = performance.now();
        this.animationFrame = window.requestAnimationFrame(this.animate);
    }

    animate() {
        let amt = (performance.now() - this.animationStart) / this.props.animationSpeed;
        if (this.props.startNum > 0) {
            amt += this.props.startNum / this.props.numStores;
        }
        if (amt >= 1) {
            this.setState({
                progress: 1,
                complete: true,
            });
            return;
        }

        this.setState({
            progress: amt,
        });
        this.animationFrame = window.requestAnimationFrame(this.animate);
    }

    render() {
        let numStores = this.props.numStores;
        let numStoresHuman = numberFormat(numStores);
        let progress = Math.ceil(this.state.progress * this.props.numStores);
        let progressHuman = numberFormat(progress);
        return (
            <div className={styles.hero}>
                <strong className={styles.apology}>
                    {gettext("oos_product.hero.apology", {
                        designer_name: this.props.designer.name,
                    }) // "Sorry! This {designer_name} item is no longer available"
                    }
                </strong>
                <div
                    className={classnames(styles.progressHolder, {
                        [styles.complete]: this.state.complete,
                    })}
                >
                    <p
                        className={styles.progressText}
                        // The animation would be unintelligible to screen readers, so just display the final text to them
                        aria-label={gettext(
                            "oos_product.hero.counter.aria_label", // "We have checked {store_count} stores"
                            { store_count: numStoresHuman }
                        )}
                    >
                        <span
                            dangerouslySetInnerHTML={{
                                __html: gettext(
                                    "oos_product.hero.counter", // "We have checked {store_count} stores"
                                    { store_count: progressHuman }
                                ),
                            }}
                        />
                        <span className={styles.progressBar} role="presentation">
                            <span
                                className={styles.inner}
                                style={{
                                    width: this.state.progress * 100 + "%",
                                }}
                            />
                        </span>
                    </p>
                    <Conditional check={!!this.props.seeSimilarLink}>
                        <TrackedButton
                            href={this.props.seeSimilarLink}
                            eventCategory="navigation"
                            eventAction="see_similar_products"
                            eventLabel="oos_page"
                        >
                            <Button className={styles.cta} styleType="secondary">
                                {gettext("oos_product.hero.btn") // "See similar products"
                                }
                            </Button>
                        </TrackedButton>
                    </Conditional>
                </div>
            </div>
        );
    }
}

OOSHero.propTypes = {
    numStores: PropTypes.number.isRequired,
    startNum: PropTypes.number.isRequired,
    animationSpeed: PropTypes.number.isRequired,
    designer: DesignerPropType.isRequired,
    seeSimilarLink: PropTypes.string,
};

OOSHero.defaultProps = {
    startNum: 200,
    animationSpeed: 3 * 1000,
};

export default OOSHero;
